import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useAuthModal } from '@/features/auth';
import { useMe } from '.';

type AuthRequiredRouteOptions = {
  skip?: boolean;
};

/**
 * Hook to guard a route from unauthorized access.
 */
const useAuthRequiredRoute = (options?: AuthRequiredRouteOptions): void => {
  const skip = options?.skip;
  const { me, loading: meLoading } = useMe();

  const { asPath, push, isReady } = useRouter();

  const {
    actions: { setIsAuthModalOpen, setRedirectTo },
  } = useAuthModal();

  useEffect(() => {
    if (isReady) {
      if (!skip && !meLoading && (!me || !me.isVerified)) {
        setIsAuthModalOpen(true);
        setRedirectTo(asPath);
        push('/');
      }
    }
  }, [
    isReady,
    meLoading,
    me,
    asPath,
    push,
    setIsAuthModalOpen,
    setRedirectTo,
    skip,
  ]);
};

export default useAuthRequiredRoute;
